import { forwardRef, type Ref, type SVGProps } from "react";
const IconTownhouseOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M21.019 12.184c0-.207.168-.375.375-.375h2.25c.207 0 .375.168.375.375v2.25a.375.375 0 0 1-.375.375h-2.25a.375.375 0 0 1-.375-.375zm-12.625-.375a.375.375 0 0 0-.375.375v2.25c0 .207.168.375.375.375h2.25a.375.375 0 0 0 .375-.375v-2.25a.375.375 0 0 0-.375-.375z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.88 2.742a2 2 0 0 0-2.76 0L2.62 7.98A2 2 0 0 0 2 9.428v18.381a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V9.428a2 2 0 0 0-.62-1.448l-5.5-5.238a2 2 0 0 0-2.76 0L16 7.619zm15.139 25.067H28V9.428L22.5 4.19 17 9.428v18.381h2.019v-7a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1zm-5 0h3v-6h-3zm-10 0h-3v-6h3zm2-7v7H15V9.428L9.5 4.19 4 9.428v18.381h2.019v-7a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconTownhouseOutlineSVG);
ForwardRef.displayName = "IconTownhouseOutline";
export { ForwardRef as IconTownhouseOutline };
